import { domAsync } from "app/client/lib/domAsync";
import { AppModel } from "app/client/models/AppModel";
import { App } from "app/client/ui/App";
import { OAuthFlowUI as OAuthFlowUIBase } from "app/client/ui/OAuthFlowCore";

import { dom } from "grainjs";

export class OAuthFlowUI extends OAuthFlowUIBase {
  public static override buildOAuthFlow(appModel: AppModel, appObj: App) {
    // Load from a dynamic chunk, to avoid including OAuthFlowImpl & co into the main bundle.
    return domAsync(
      import("app/client/ui/OAuthFlowImpl" /* webpackChunkName: "OAuthFlowImpl" */)
        .then(m => dom.create(m.OAuthFlow, appModel, appObj)),
    );
  }
}
